/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { CtaForm } from 'components/products'

import styled from '@emotion/styled'


const StyledDiv = styled('div')`
  text-align: center;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 48px;

  form {
    justify-content: center;
  }
`

const StyledH4 = styled('h4')`
  font-family: ${({ theme }) => theme.fonts.light};
  font-size: 22px;
  color: ${({ theme }) => theme.secondary.base};
`

const FooterCta = ({ children, productId }) => (
  <StyledDiv>
    <StyledH4>{children}</StyledH4>
    <CtaForm productId={productId} blockedDisplay={true} />
  </StyledDiv>
)

FooterCta.propTypes = {
  children: PropTypes.any.isRequired,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
}

export default FooterCta
